// import { useState, useEffect } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import axios from "axios";
// import { SubmitButton } from "../../components/Input";
// import {
//     CheckBox,
// } from "../../components/Input";
// import { API_URL } from "../../config";
// import { showToast } from "../../components/toast";
// import LoadingSpinner from "../../components/LoadingSpinner";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";

// const AnalystViewForm = () => {
//     const navigate = useNavigate();
//     const { id } = useParams();
//     const [loading, setLoading] = useState(false);
//     const token = localStorage.getItem("authToken");

//     const [formData, setFormData] = useState({
//         date: new Date().toISOString().split("T")[0],
//         marketStatus: "Markets Open",
//         updatedAt: "",
//         isActive: true,
//         niftyOutlook: { highlights: [""] },
//         bankNiftyOutlook: { highlights: [""] },
//         marketOutlook: { content: "" },
//     });

//     const [niftyChart, setNiftyChart] = useState(null);
//     const [bankNiftyChart, setBankNiftyChart] = useState(null);
//     const [niftyChartPreview, setNiftyChartPreview] = useState(null);
//     const [bankNiftyChartPreview, setBankNiftyChartPreview] = useState(null);

//     useEffect(() => {
//         if (id) {
//             fetchAnalystView(id);
//         }
//     }, [id]);

//     const fetchAnalystView = async (viewId) => {
//         setLoading(true);
//         try {
//             const response = await axios.get(`${API_URL}analyst-views/${viewId}`, {
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     accept: "*/*",
//                 },
//             });

//             if (response.data?.success && response.data?.data) {
//                 const data = response.data.data;
//                 setFormData({
//                     date: data.date ? new Date(data.date).toISOString().split("T")[0] : "",
//                     marketStatus: data.marketStatus || "",
//                     updatedAt: data.updatedAt || "",
//                     isActive: data.isActive === 1,
//                     niftyOutlook: {
//                         highlights: Array.isArray(data.niftyOutlook?.highlights)
//                             ? data.niftyOutlook.highlights
//                             : [""]
//                     },
//                     bankNiftyOutlook: {
//                         highlights: Array.isArray(data.bankNiftyOutlook?.highlights)
//                             ? data.bankNiftyOutlook.highlights
//                             : [""]
//                     },
//                     marketOutlook: data.marketOutlook || { content: "" },
//                 });

//                 if (data.niftyChart) setNiftyChartPreview(data.niftyChart);
//                 if (data.bankNiftyChart) setBankNiftyChartPreview(data.bankNiftyChart);
//             }
//         } catch (error) {
//             console.error("Error fetching analyst view:", error);
//             showToast.error("Failed to fetch analyst view data");
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleInputChange = (e) => {
//         const { name, value, type, checked } = e.target;
//         setFormData((prev) => ({
//             ...prev,
//             [name]: type === "checkbox" ? checked : value,
//         }));
//     };

//     const handleOutlookChange = (outlookType, field, value) => {
//         setFormData(prev => ({
//             ...prev,
//             [outlookType]: {
//                 ...prev[outlookType],
//                 [field]: value
//             }
//         }));
//     };

//     const handleHighlightChange = (outlookType, index, value) => {
//         const highlights = [...formData[outlookType].highlights];
//         highlights[index] = value;
//         setFormData((prev) => ({
//             ...prev,
//             [outlookType]: { ...prev[outlookType], highlights },
//         }));
//     };

//     const addHighlight = (outlookType) => {
//         setFormData((prev) => ({
//             ...prev,
//             [outlookType]: {
//                 ...prev[outlookType],
//                 highlights: [...prev[outlookType].highlights, ""],
//             },
//         }));
//     };

//     const removeHighlight = (outlookType, index) => {
//         const highlights = formData[outlookType].highlights.filter((_, i) => i !== index);
//         setFormData((prev) => ({
//             ...prev,
//             [outlookType]: { ...prev[outlookType], highlights },
//         }));
//     };

//     const handleFileChange = (e, setter, previewSetter) => {
//         const file = e.target.files[0];
//         if (file) {
//             setter(file);
//             previewSetter(URL.createObjectURL(file));
//         }
//     };



//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setLoading(true);

//         const submitData = new FormData();
//         submitData.append("date", formData.date);
//         submitData.append("marketStatus", formData.marketStatus);
//         submitData.append("updatedAt", formData.updatedAt);
//         submitData.append("isActive", formData.isActive ? 1 : 0);
//         submitData.append("niftyOutlook", JSON.stringify(formData.niftyOutlook));
//         submitData.append("bankNiftyOutlook", JSON.stringify(formData.bankNiftyOutlook));
//         submitData.append("marketOutlook", JSON.stringify(formData.marketOutlook));

//         if (niftyChart) {
//             submitData.append("niftyChart", niftyChart);
//         }
//         if (bankNiftyChart) {
//             submitData.append("bankNiftyChart", bankNiftyChart);
//         }

//         try {
//             const url = id
//                 ? `${API_URL}analyst-views/${id}`
//                 : `${API_URL}analyst-views`;

//             const response = await axios({
//                 method: id ? "put" : "post",
//                 url,
//                 data: submitData,
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     "Content-Type": "multipart/form-data",
//                 },
//             });

//             if (response.data.success || response.status === 201) {
//                 showToast.success(id ? "Analyst view updated" : "Analyst view created");
//                 navigate("/research/analystView");
//             }
//         } catch (error) {
//             console.error("Error saving analyst view:", error);
//             showToast.error(error.response?.data?.message || "Error saving analyst view");
//         } finally {
//             setLoading(false);
//         }
//     };

//     if (loading && id) return <LoadingSpinner />;

//     return (
//         <div id="page-container" className="page-header-fixed page-sidebar-fixed fade in">
//             <div id="content" className="">
//                 <div className="panel panel-default with-rounded-corner with-shadow">
//                     <form onSubmit={handleSubmit}>
//                         <div className="panel-heading border-0 p-3">
//                             <h4 className="panel-title">{id ? "Edit" : "Add"} Analyst View</h4>
//                         </div>
//                         <div className="panel-body">
//                             <div className="row">
//                                 {/* Date & Market Status */}
//                                 <div className="col-md-4">
//                                     <div className="form-group">
//                                         <label>Date</label>
//                                         <input
//                                             type="date"
//                                             name="date"
//                                             className="form-control"
//                                             value={formData.date}
//                                             onChange={handleInputChange}
//                                             required
//                                         />
//                                     </div>
//                                 </div>
//                                 <div className="col-md-4">
//                                     <div className="form-group">
//                                         <label>Market Status</label>
//                                         <select
//                                             name="marketStatus"
//                                             className="form-control"
//                                             value={formData.marketStatus}
//                                             onChange={handleInputChange}
//                                         >
//                                             <option value="Markets Open">Markets Open</option>
//                                             <option value="Markets Closed">Markets Closed</option>
//                                             <option value="Pre-Market">Pre-Market</option>
//                                             <option value="Post-Market">Post-Market</option>
//                                         </select>
//                                     </div>
//                                 </div>
//                                 <div className="col-md-4">
//                                     <div className="form-group">
//                                         <label>Updated At (Status Text)</label>
//                                         <input
//                                             type="text"
//                                             name="updatedAt"
//                                             className="form-control"
//                                             placeholder="e.g. Updated after market close"
//                                             value={formData.updatedAt}
//                                             onChange={handleInputChange}
//                                         />
//                                     </div>
//                                 </div>

//                                 {/* Charts */}
//                                 <div className="col-md-6">
//                                     <div className="form-group">
//                                         <label>Nifty Chart</label>
//                                         <input
//                                             type="file"
//                                             className="form-control"
//                                             onChange={(e) => handleFileChange(e, setNiftyChart, setNiftyChartPreview)}
//                                             accept="image/*"
//                                         />
//                                         {niftyChartPreview && (
//                                             <div className="mt-2 border p-1" style={{ maxWidth: "200px" }}>
//                                                 <img src={niftyChartPreview} alt="Nifty Preview" className="img-fluid" />
//                                             </div>
//                                         )}
//                                     </div>
//                                 </div>
//                                 <div className="col-md-6">
//                                     <div className="form-group">
//                                         <label>Bank Nifty Chart</label>
//                                         <input
//                                             type="file"
//                                             className="form-control"
//                                             onChange={(e) => handleFileChange(e, setBankNiftyChart, setBankNiftyChartPreview)}
//                                             accept="image/*"
//                                         />
//                                         {bankNiftyChartPreview && (
//                                             <div className="mt-2 border p-1" style={{ maxWidth: "200px" }}>
//                                                 <img src={bankNiftyChartPreview} alt="Bank Nifty Preview" className="img-fluid" />
//                                             </div>
//                                         )}
//                                     </div>
//                                 </div>

//                                 <hr className="my-4" />

//                                 {/* Nifty Outlook Highlights */}
//                                 <div className="col-md-6">
//                                     <div className="card mb-3 p-3">
//                                         <div className="d-flex justify-content-between align-items-center mb-2">
//                                             <label className="mb-0"><strong>Nifty Outlook Highlights</strong></label>
//                                             <button type="button" className="btn btn-xs btn-primary" onClick={() => addHighlight("niftyOutlook")}>
//                                                 <FontAwesomeIcon icon={faPlus} />
//                                             </button>
//                                         </div>
//                                         {Array.isArray(formData.niftyOutlook?.highlights) && formData.niftyOutlook.highlights.map((highlight, index) => (
//                                             <div key={index} className="input-group mb-2">
//                                                 <input
//                                                     type="text"
//                                                     className="form-control input-sm"
//                                                     value={highlight}
//                                                     onChange={(e) => handleHighlightChange("niftyOutlook", index, e.target.value)}
//                                                     placeholder="Enter highlight"
//                                                 />
//                                                 <button type="button" className="btn btn-danger btn-sm" onClick={() => removeHighlight("niftyOutlook", index)}>
//                                                     <FontAwesomeIcon icon={faTrash} />
//                                                 </button>
//                                             </div>
//                                         ))}
//                                     </div>
//                                 </div>

//                                 {/* Bank Nifty Outlook Highlights */}
//                                 <div className="col-md-6">
//                                     <div className="card mb-3 p-3">
//                                         <div className="d-flex justify-content-between align-items-center mb-2">
//                                             <label className="mb-0"><strong>Bank Nifty Outlook Highlights</strong></label>
//                                             <button type="button" className="btn btn-xs btn-primary" onClick={() => addHighlight("bankNiftyOutlook")}>
//                                                 <FontAwesomeIcon icon={faPlus} />
//                                             </button>
//                                         </div>
//                                         {Array.isArray(formData.bankNiftyOutlook?.highlights) && formData.bankNiftyOutlook.highlights.map((highlight, index) => (
//                                             <div key={index} className="input-group mb-2">
//                                                 <input
//                                                     type="text"
//                                                     className="form-control input-sm"
//                                                     value={highlight}
//                                                     onChange={(e) => handleHighlightChange("bankNiftyOutlook", index, e.target.value)}
//                                                     placeholder="Enter highlight"
//                                                 />
//                                                 <button type="button" className="btn btn-danger btn-sm" onClick={() => removeHighlight("bankNiftyOutlook", index)}>
//                                                     <FontAwesomeIcon icon={faTrash} />
//                                                 </button>
//                                             </div>
//                                         ))}
//                                     </div>
//                                 </div>

//                                 {/* Market Outlook Content */}
//                                 <div className="col-md-12">
//                                     <div className="form-group">
//                                         <label><strong>Market Outlook Content</strong></label>
//                                         <textarea
//                                             className="form-control"
//                                             rows="6"
//                                             value={formData.marketOutlook.content}
//                                             onChange={(e) => handleOutlookChange("marketOutlook", "content", e.target.value)}
//                                             placeholder="Enter detailed market outlook..."
//                                         />
//                                     </div>
//                                 </div>

//                                 {/* Is Active */}
//                                 <div className="col-md-2 mt-2">
//                                     <CheckBox
//                                         label="Is Active"
//                                         fieldname="isActive"
//                                         checked={formData.isActive}
//                                         onChange={handleInputChange}
//                                     />
//                                 </div>


//                                 <div className="col-md-12 mt-4">
//                                     <SubmitButton
//                                         pageBack={"/research/analystView"}
//                                         handleSubmit={handleSubmit}
//                                         isLoading={loading}
//                                     />
//                                 </div>
//                             </div>
//                         </div>
//                     </form>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default AnalystViewForm;


import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { SubmitButton } from "../../components/Input";
import {
    CheckBox,
} from "../../components/Input";
import { API_URL } from "../../config";
import { showToast } from "../../components/toast";
import LoadingSpinner from "../../components/LoadingSpinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const AnalystViewForm = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const token = localStorage.getItem("authToken");

    const [formData, setFormData] = useState({
        date: new Date().toISOString().split("T")[0],
        marketStatus: "Markets Open",
        updatedAt: "",
        isActive: true,
        isPost: "true",
        niftyOutlook: { content: "" },
        bankNiftyOutlook: { content: "" },
        marketOutlook: { content: "" },
    });

    const [niftyChart, setNiftyChart] = useState(null);
    const [bankNiftyChart, setBankNiftyChart] = useState(null);
    const [niftyChartPreview, setNiftyChartPreview] = useState(null);
    const [bankNiftyChartPreview, setBankNiftyChartPreview] = useState(null);

    const modules = {
        toolbar: [
            [{ 'header': [1, 2, 3, false] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['link'],
            ['clean']
        ],
    };

    const formats = [
        'header',
        'bold', 'italic', 'underline', 'strike', 'blockquote',
        'list', 'bullet',
        'link'
    ];

    useEffect(() => {
        if (id) {
            fetchAnalystView(id);
        }
    }, [id]);

    const fetchAnalystView = async (viewId) => {
        setLoading(true);
        try {
            const response = await axios.get(`${API_URL}analyst-views/${viewId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    accept: "*/*",
                },
            });

            if (response.data?.success && response.data?.data) {
                const data = response.data.data;
                setFormData({
                    date: data.date ? new Date(data.date).toISOString().split("T")[0] : "",
                    marketStatus: data.marketStatus || "",
                    updatedAt: data.updatedAt || "",
                    isActive: data.isActive === 1,
                    isPost: data.isPost ?? "false",
                    niftyOutlook: {
                        content: data.niftyOutlook?.content ||
                            (Array.isArray(data.niftyOutlook?.highlights) && data.niftyOutlook.highlights.length > 0
                                ? `<ul>${data.niftyOutlook.highlights.map(h => `<li>${h}</li>`).join('')}</ul>`
                                : "")
                    },
                    bankNiftyOutlook: {
                        content: data.bankNiftyOutlook?.content ||
                            (Array.isArray(data.bankNiftyOutlook?.highlights) && data.bankNiftyOutlook.highlights.length > 0
                                ? `<ul>${data.bankNiftyOutlook.highlights.map(h => `<li>${h}</li>`).join('')}</ul>`
                                : "")
                    },
                    marketOutlook: data.marketOutlook || { content: "" },
                });

                if (data.niftyChart) setNiftyChartPreview(data.niftyChart);
                if (data.bankNiftyChart) setBankNiftyChartPreview(data.bankNiftyChart);
            }
        } catch (error) {
            console.error("Error fetching analyst view:", error);
            showToast.error("Failed to fetch analyst view data");
        } finally {
            setLoading(false);
        }
    };

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleOutlookChange = (outlookType, field, value) => {
        setFormData(prev => ({
            ...prev,
            [outlookType]: {
                ...prev[outlookType],
                [field]: value
            }
        }));
    };

    const handleFileChange = (e, setter, previewSetter) => {
        const file = e.target.files[0];
        if (file) {
            setter(file);
            previewSetter(URL.createObjectURL(file));
        }
    };



    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const submitData = new FormData();
        submitData.append("date", formData.date);
        submitData.append("marketStatus", formData.marketStatus);
        submitData.append("updatedAt", formData.updatedAt);
        submitData.append("isActive", formData.isActive ? 1 : 0);
        submitData.append("isPost", formData.isPost);
        submitData.append("niftyOutlook", JSON.stringify(formData.niftyOutlook));
        submitData.append("bankNiftyOutlook", JSON.stringify(formData.bankNiftyOutlook));
        submitData.append("marketOutlook", JSON.stringify(formData.marketOutlook));

        if (niftyChart) {
            submitData.append("niftyChart", niftyChart);
        }
        if (bankNiftyChart) {
            submitData.append("bankNiftyChart", bankNiftyChart);
        }

        try {
            const url = id
                ? `${API_URL}analyst-views/${id}`
                : `${API_URL}analyst-views`;

            const response = await axios({
                method: id ? "put" : "post",
                url,
                data: submitData,
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                },
            });

            if (response.data.success || response.status === 201 || response.status === 200) {
                showToast.success(id ? "Analyst view updated" : "Analyst view created");
                navigate("/research/analystView");
            }
        } catch (error) {
            console.error("Error saving analyst view:", error);
            showToast.error(error.response?.data?.message || "Error saving analyst view");
        } finally {
            setLoading(false);
        }
    };

    if (loading && id) return <LoadingSpinner />;

    return (
        <div id="page-container" className="page-header-fixed page-sidebar-fixed fade in">
            <div id="content" className="">
                <div className="panel panel-default with-rounded-corner with-shadow">
                    <form onSubmit={handleSubmit}>
                        <div className="panel-heading border-0 p-3">
                            <h4 className="panel-title">{id ? "Edit" : "Add"} Analyst View</h4>
                        </div>
                        <div className="panel-body">
                            <div className="row">
                                {/* Date & Market Status */}
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Date</label>
                                        <input
                                            type="date"
                                            name="date"
                                            className="form-control"
                                            value={formData.date}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    {/* <div className="form-group">
                                        <label>Market Status</label>
                                        <select
                                            name="marketStatus"
                                            className="form-control"
                                            value={formData.marketStatus}
                                            onChange={handleInputChange}
                                        >
                                            <option value="Markets Open">Markets Open</option>
                                            <option value="Markets Closed">Markets Closed</option>
                                            <option value="Pre-Market">Pre-Market</option>
                                            <option value="Post-Market">Post-Market</option>
                                        </select>
                                    </div> */}
                                </div>
                                {/* <div className="col-md-4">
                                    <div className="form-group">
                                        <label>Updated At (Status Text)</label>
                                        <input
                                            type="text"
                                            name="updatedAt"
                                            className="form-control"
                                            placeholder="e.g. Updated after market close"
                                            value={formData.updatedAt}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </div> */}

                                {/* Charts */}
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Nifty Chart</label>
                                        <input
                                            type="file"
                                            className="form-control"
                                            onChange={(e) => handleFileChange(e, setNiftyChart, setNiftyChartPreview)}
                                            accept="image/*"
                                        />
                                        {niftyChartPreview && (
                                            <div className="mt-2 border p-1" style={{ maxWidth: "200px" }}>
                                                <img src={niftyChartPreview} alt="Nifty Preview" className="img-fluid" />
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label>Bank Nifty Chart</label>
                                        <input
                                            type="file"
                                            className="form-control"
                                            onChange={(e) => handleFileChange(e, setBankNiftyChart, setBankNiftyChartPreview)}
                                            accept="image/*"
                                        />
                                        {bankNiftyChartPreview && (
                                            <div className="mt-2 border p-1" style={{ maxWidth: "200px" }}>
                                                <img src={bankNiftyChartPreview} alt="Bank Nifty Preview" className="img-fluid" />
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {/* <hr className="my-4" /> */}

                                {/* Nifty Outlook */}
                                <div className="col-md-6">
                                    <div className="form-group mb-3">
                                        <label><strong>Nifty Outlook</strong></label>
                                        <div style={{ background: 'white' }}>
                                            <ReactQuill
                                                theme="snow"
                                                value={formData.niftyOutlook.content}
                                                onChange={(content) => handleOutlookChange("niftyOutlook", "content", content)}
                                                modules={modules}
                                                formats={formats}
                                                style={{ height: '200px', marginBottom: '50px' }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Bank Nifty Outlook */}
                                <div className="col-md-6">
                                    <div className="form-group mb-3">
                                        <label><strong>Bank Nifty Outlook</strong></label>
                                        <div style={{ background: 'white' }}>
                                            <ReactQuill
                                                theme="snow"
                                                value={formData.bankNiftyOutlook.content}
                                                onChange={(content) => handleOutlookChange("bankNiftyOutlook", "content", content)}
                                                modules={modules}
                                                formats={formats}
                                                style={{ height: '200px', marginBottom: '50px' }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Market Outlook Content */}
                                {/* <div className="col-md-12">
                                    <div className="form-group">
                                        <label><strong>Market Outlook Content</strong></label>
                                        <textarea
                                            className="form-control"
                                            rows="6"
                                            value={formData.marketOutlook.content}
                                            onChange={(e) => handleOutlookChange("marketOutlook", "content", e.target.value)}
                                            placeholder="Enter detailed market outlook..."
                                        />
                                    </div>
                                </div> */}

                                {/* Is Active */}
                                <div className="col-md-2 mt-2">
                                    <CheckBox
                                        label="Is Active"
                                        fieldname="isActive"
                                        checked={formData.isActive}
                                        onChange={handleInputChange}
                                    />
                                </div>

                                <div className="col-md-2 mt-2">
                                    <CheckBox
                                        label="Is Post"
                                        fieldname="isPost"
                                        checked={formData.isPost === "true"}
                                        onChange={(e) =>
                                            setFormData(prev => ({
                                                ...prev,
                                                isPost: e.target.checked ? "true" : "false"
                                            }))
                                        }
                                    />
                                </div>

                                <div className="col-md-12 mt-4">
                                    <SubmitButton
                                        pageBack={"/research/analystView"}
                                        handleSubmit={handleSubmit}
                                        isLoading={loading}
                                    />
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AnalystViewForm;
